export interface TalabProduct {
  id: string
  name: string
  price: string
  image: string
  /** Short contextual reason shown when the AI recommends this product. */
  reason?: string
  /** Whether the merchant publishes this product to the Talab marketplace. */
  marketplace?: boolean
}

/** Nova Sportswear — the example merchant followed across all three slides. */
export const NOVA_PRODUCTS: TalabProduct[] = [
  {
    id: 'aero',
    name: 'Aero Pace 5',
    price: 'AED 549',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/611f0bcc-66b3-40d5-8aae-8ca8e16c8227.jpg',
    reason: 'Best for Long Distance',
    marketplace: true,
  },
  {
    id: 'cloud',
    name: 'Cloud Lite 2',
    price: 'AED 479',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/15201a84-8020-41ef-89e2-875b348230b8.jpg',
    reason: 'Lightest',
    marketplace: false,
  },
  {
    id: 'elite',
    name: 'Marathon Elite',
    price: 'AED 589',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/d99dc201-d160-429d-bddb-a69008a78649.jpg',
    reason: 'Best Value',
    marketplace: true,
  },
  {
    id: 'trail',
    name: 'Trail Grip X',
    price: 'AED 615',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/69b4803d-de44-4481-a902-942162d0cc19.jpg',
    marketplace: true,
  },
  {
    id: 'studio',
    name: 'Studio Daily',
    price: 'AED 399',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ed6c4ca7-6bb1-47db-b534-ce8e2dd1ade6.jpg',
    marketplace: false,
  },
]

/** Products from other merchants — used to give the marketplace real breadth. */
export const MARKETPLACE_PRODUCTS: TalabProduct[] = [
  {
    id: 'watch',
    name: 'Pulse GPS Watch',
    price: 'AED 899',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/627457d5-e194-4e13-bf94-d1ffaf6953bc.jpg',
  },
  {
    id: 'backpack',
    name: 'Trail Pack 18L',
    price: 'AED 320',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/a62ac8ea-9430-42df-a25c-2e48ef815de1.jpg',
  },
  {
    id: 'jacket',
    name: 'Windshell Jacket',
    price: 'AED 410',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/21e77ef4-ccbe-47f4-baa2-5f7dfa28fe51.jpg',
  },
  {
    id: 'bottle',
    name: 'Thermo Flask',
    price: 'AED 95',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7eff3675-a4ea-43bd-a81e-6a0ffb10058b.jpg',
  },
  {
    id: 'earbuds',
    name: 'Sprint Buds',
    price: 'AED 540',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/3083878e-d143-4161-89a6-a073e95abc20.jpg',
  },
]
